import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getClubList } from '../../../store/selectors';
import { toggleCareerMenu } from '../../../store/actionCreators/career';
import '../../../assets/stylesheets/CareerSlide/CareerMenu.scss';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import CareerMenuRow from './MenuRow';

const CareerMenu = ({selectedGame, setSelectedGame, selectedClub, setSelectedClub}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const careerMenu = useSelector(state => state.careerMenu);
    const clubsList = useSelector(getClubList);
    const closeMenu = useCallback(() => {
        dispatch(toggleCareerMenu());
    });
    console.log(clubsList);

    useEffect(() => {
        console.log(careerMenu);
    }, [careerMenu]);

    return (
        <div className={`careerMenu ${careerMenu ? 'opened' : 'closed'}`}>
            <div className="filtersHeader"><span>{t('career.menu.filters')}</span> <button onClick={() => closeMenu()}>X</button></div>
            <div className="entriesList">
                {
                    clubsList.map((club, index) => <CareerMenuRow 
                        selectedGame={selectedGame} 
                        setSelectedGame={setSelectedGame} 
                        selectedClub={selectedClub} 
                        setSelectedClub={setSelectedClub} 
                        club={club} 
                        key={index}
                    ></CareerMenuRow>)
                }
            </div>
        </div>
    )
};

export default CareerMenu;